import { useFormContext } from 'react-hook-form';
import React, { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ShouldRender } from 'components/ShouldRender';
import { useUserPermissions } from 'services/user/permissions';
import { useModal } from 'store/modals';
import { UserAdministrationModalContext } from '../../../../../../UserAdministrationModalContext';
import { DisableUser } from '../../../../../Users/components/DisableUser';
import { DeleteUser } from '../../../../../Users/components/DeleteUser';
import { discardChangesOnCancel } from '../../../../../discardChangesOnCancel';
import styles from './styles.module.scss';

export const FormActions = ({ isLoading, onSubmit }) => {

  const intl = useIntl();
  const modal = useModal();
  const userAdministrationContext = useContext(UserAdministrationModalContext);

  const formContext = useFormContext();
  const { formState } = formContext;
  const { checkPermission } = useUserPermissions();
  const canDisableAsAdmin = checkPermission('admin-users', 'delete');
  const isSystemAdmin = checkPermission('system-admin', 'create', 'read', 'update', 'delete', 'assign');

  return (
    <div className={styles.formActions}>
      <div className={styles.actionContainer}>
        <Button
          basic
          name="cancel-user-details"
          type="button"
          disabled={isLoading}
          onClick={() => discardChangesOnCancel(intl, userAdministrationContext, modal)}

        >
          <FormattedMessage id="cancel" />
        </Button>
        <Button
          primary
          name="submit-user-details"
          onClick={formContext.handleSubmit(onSubmit)}
          disabled={!formState.isDirty || isLoading}
          loading={isLoading}
        >
          <FormattedMessage id="saveChanges" />
        </Button>
      </div>
      <ShouldRender condition={userAdministrationContext.selectedUser && (canDisableAsAdmin || isSystemAdmin)}>
        <div className={styles.secondaryActionContainer}>
          <DisableUser />
          <DeleteUser />
        </div>
      </ShouldRender>
    </div>
  );
};
